const firebaseConfig = {
    apiKey: "AIzaSyArm0MuUG_-rzXVRw9luym_oh6y_1Ah4L0",
    authDomain: "tralive-as.firebaseapp.com",
    projectId: "tralive-as",
    storageBucket: "tralive-as.appspot.com",
    messagingSenderId: "357176543071",
    appId: "1:357176543071:web:c1d1fd7a67e2fd3c5f98ea"
  };

export default firebaseConfig;